export const MENU_URL = process.env.REACT_APP_HOST;
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL;
export const ICONS_URL = process.env.REACT_APP_ICONS_URL;

export const LANG = "lang";
export const TUTORIAL = "tutorial";
export const CONFIG_LAST_UPDATED = "coinfigLastUpdated";

export const DEFAULT_LANG = +process.env.REACT_APP_DEFAULT_LANG;